import React from 'react';

const AppBanner = ({ className = "" }) => {
    return (
        <div className={`app-banner ${className}`}>
            <a 
                href="https://play.google.com/store/apps/details?id=com.muware.echonote" 
                target="_blank" 
                rel="noopener noreferrer"
                className="app-banner-link"
            >
                <img 
                    src="/images/banniere_app.webp" 
                    alt="Download EchoNote - Voice to Text App on Google Play Store" 
                    className="app-banner-image"
                />
            </a>
        </div>
    );
};

export default AppBanner; 